// extracted by mini-css-extract-plugin
module.exports = {"container":"bottleRibbon-module__container---wYPw"};